/**
 * @fileoverview Hook UI Layer para gestión visual del estado de entrega en Inbox.
 */
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DELIVERY_STATUS_OPTIONS,
  DELIVERY_STATUS_STYLES
} from '../../../modules/Orders/constants/deliveryStatus';

export default function useCustomerOrderDeliveryStatusUI(order, handleStatusChange) {
  const { t } = useTranslation('Orders');

  const deliveryStatesOptionsMap = useMemo(() => DELIVERY_STATUS_OPTIONS.map((value) => ({
    value,
    label: t(`delivery_status.${value}`),
    containerClassName: DELIVERY_STATUS_STYLES[value],
    onClick: () => handleStatusChange(value)
  })), [handleStatusChange, t]);

  const currentStatus = order.delivery_status || 'delivery_pending';

  const deliveryStatusOptions = useMemo(
    () => deliveryStatesOptionsMap.filter((option) => option.value !== currentStatus),
    [deliveryStatesOptionsMap, currentStatus]
  );

  const deliveryStatusLabel = useMemo(() => {
    const found = deliveryStatesOptionsMap.find((option) => option.value === currentStatus);
    return found ? found.label : t('delivery_status.delivery_pending');
  }, [currentStatus, deliveryStatesOptionsMap, t]);

  const containerClassNameDeliveryStatus = useMemo(() => {
    const found = deliveryStatesOptionsMap.find((option) => option.value === currentStatus);
    return found ? found.containerClassName : '!tw-bg-gray-50 !tw-text-gray-700';
  }, [currentStatus, deliveryStatesOptionsMap]);

  return {
    deliveryStatusLabel,
    deliveryStatusOptions,
    containerClassNameDeliveryStatus
  };
}
